mainweb = {
    init : function() {
        mainweb.main_menu_show();
        mainweb.main_menu_small_open();
        mainweb.main_menu_small_close();
        mainweb.act_cover_link();
        mainweb.act_cover_form();
        mainweb.web_alert_close();
        mainweb.filterform('filterform');
        mainweb.get_size_range();
        mainweb.get_size_range_drop();
        mainweb.do_sort();
        mainweb.get_collectible_form();
        mainweb.dismiss_right_canvas();
        mainweb.call_filters();
        mainweb.dismiss_filters();
        mainweb.get_total_cart_count();
        mainweb.get_cart_full();
        mainweb.get_pr_question_form();
        mainweb.get_total_wish_count();
        mainweb.wish_add();

        $.ajaxSetup({
            cache: false,
        });

        $("[data-bs-toggle='tooltip']").tooltip();
        $('body').on('click', '.btn-close', function() {
            $(this).parents('.alert').remove();
        });

        $(document).on('click', function(e) {
			if ($(e.target).closest(".nav-option-collaps-inner").length === 0) {
				mainweb.main_menu_hide();
			}
        });

        $(document).on('keyup', function(e) {
			if (e.key == 'Escape') {
                //Close Alert
                var _alert_trigger = $('.web-alert-close');
				if(_alert_trigger.length > 0) {
                    _alert_trigger.trigger('click');
                }
            }
        });

        $(window).on('resize', function() {
            if($(window).width() > 991) {
                if($('.page_cover_menu_lg').length > 0) {
                    $('.page_cover_menu_lg').css('top', $('header').height());
                }
            }
        });

        $('body').on('click', '.cart-mini-toggle', function(e) {
            mainweb.get_cart_mini();
            e.preventDefault();
        });

        $('body').on('click', '.del-item-card-mini', function(e) {
            mainweb.get_cart_delete($(this), 'mini');
            e.preventDefault();
        });
        $('body').on('click', '.del-item-card-full', function(e) {
            mainweb.get_cart_delete($(this), 'full');
            e.preventDefault();
        });
        $('body').on('click', '.get-full-filter', function(e) {
            mainweb.get_full_filter($('.fullattr').html(), $('.curfilt').html());
            e.preventDefault();
        });
    },
    main_menu_show : function() {
        $('.nav-ption-trigger').on('click', function(e) {

            //page_cover_menu_lg

            var nav_height = $('header').height(),
                filterform_page_cover = '<div class="page_cover_menu_lg" style="top: '+nav_height+'px"></div>';

            if($(window).width() > 991) {
                if($('.page_cover_menu_lg').length == 0) {
                    $('body').append(filterform_page_cover);
                }
                $('body').addClass('no-scroll-menu');
            }

            if ($(this).hasClass('nav-ption-trigger-active')) {
                mainweb.main_menu_hide();
            } else {
                $('.nav-ption-trigger-active').removeClass('nav-ption-trigger-active');
                $(this).addClass('nav-ption-trigger-active');
                $('.nav-option-active').removeClass('nav-option-active');
                $(this).parents('li').find('.nav-option-collaps').addClass('nav-option-active')
            }
            e.preventDefault();
            e.stopPropagation();
        });
    },
    main_menu_hide : function() {
        $('.nav-option-active').removeClass('nav-option-active');
        $('.nav-ption-trigger-active').removeClass('nav-ption-trigger-active');
        $('body').removeClass('no-scroll-menu');
        $('.page_cover_menu_lg').remove();
    },
    main_menu_small_open : function() {
        $('body').on('click', '.get-main-menu', function() {
            $('body').addClass('no-scroll');
            $('body').append('<div class="page_cover_menu hide-sm-main-menu"></div>');
            $('.topnav').addClass('main-menu-wrapper-active');
        });
    },
    main_menu_small_close : function () {
        $('body').on('click', '.hide-sm-main-menu', function() {
            $('body').removeClass('no-scroll');
            $('.topnav').removeClass('main-menu-wrapper-active');
            $('.page_cover_menu').fadeOut(function() {
                $('.page_cover_menu').remove();
            });
        });
    },
    do_cover : function($option) {
		cover_html = '<div class="page_cover"><div class="spinner-border text-primary" role="status"></div></div>';
		if($option == 'add') {
			$('.page_cover').remove();
			$('body').append(cover_html);
		} else {
			$('.page_cover').remove();
		}
    },
    check_key_press : function(cur_evt) {
		if(cur_evt === "" || typeof cur_evt === "undefined") {
			return false;
		}
		if(cur_evt.ctrlKey) {
			return true;
		}
		else if(cur_evt.altKey) {
			return true;
		}
		else if(cur_evt.shiftKey) {
			return true;
		}
		else if(cur_evt.metaKey) {
			return true;
		} else {
			return false;
		}
	},
    act_cover_link: function() {
        $('body').on('click', '.act_cover_link', function(e) {
            if(!mainweb.check_key_press(e)) {
                e.preventDefault();
                var _target = $(this).prop('href');
                mainweb.do_cover('add');
                window.location.href = _target;
            }
        });
    },
    act_cover_form: function() {
        $('body').on('click', '.act_cover_form', function(e) {
            var _target = $(this).parents('form'),
                _do_process = true;
            _target.find('input:required').each(function() {
                if($(this).val() == '' || typeof $(this).val() == 'undefined') {
                    _do_process = false;
                }
            });
            if(_do_process) {
                mainweb.do_cover('add');
                _target.trigger('submit');
            } else {
                mainweb.web_alert('error', 'Please fill out all required field first.');
                //web_alert : function (type, message, title, btn)
            }
            e.preventDefault();
        });
    },
    web_alert : function (type, message, title, btn) {
        var _type = type.toLowerCase(),
            _message = message,
            _title_custom = title,
            _btn_custom = btn;
            _btn_set = '<a href="javascript:void(0);" class="btn btn-light btn-md web-alert-close">Dismiss</a>';


        if(_message == '' || typeof _message =='undefined') {
            _message = '...';
        }
        if(_btn_custom != '' && typeof _btn_custom !='undefined') {
            _btn_set = _btn_custom;
        }

        switch(_type) {
            case 'error':
                _class = 'text-danger';
                _icon = 'exclamation-circle';
                _title = 'Error';
                break;
            case 'warning':
                _class = 'text-warning';
                _icon = 'exclamation-diamond';
                _title = 'Warning';
                break;
            case 'success':
                _class = 'text-success';
                _icon = 'check2-all';
                _title = 'Success';
                break;
            case 'info':
                _class = 'text-info';
                _icon = 'info-circle';
                _title = 'Info';
                break;
            default:
                _class = 'text-primary';
                _icon = 'check2-all';
                _title = '';
            }
        _title = (_title_custom != '' && typeof(_title_custom) != 'undefined') ? _title_custom : _title;

        var _alert =            '<div class="card alert-card alert-card-comp">';
        var _alert = _alert +       '<div class="card-header pt-3 pb-3">';
        var _alert = _alert +           '<svg class="bi me-2 '+_class+'" width="25" height="25" fill="currentColor">';
        var _alert = _alert +               '<use xlink:href="/bootstrap-icons/bootstrap-icons.svg#'+_icon+'"/>';
        var _alert = _alert +           '</svg>';
        var _alert = _alert +           _title;
        var _alert = _alert +       '</div>';
        var _alert = _alert +       '<div class="card-body pt-3 pb-3">'+_message+'</div>';
        var _alert = _alert +       '<div class="card-footer pt-3 pb-3 text-end">';
        var _alert = _alert +           _btn_set;
        var _alert = _alert +       '</div>';
        var _alert = _alert +   '</div>';
        var _alert = _alert +   '<div class="page_cover_alert alert-card-comp web-alert-close"></div>';

        $('body').append(_alert);

    },
    web_alert_close : function () {
        $('body').on('click', '.web-alert-close', function() {
            $('.alert-card').animate({'margin-top': '100px', 'opacity' : '0'}, 500);
            $('.page_cover_alert').fadeOut(500, function() {
                $('.alert-card-comp').remove();
            });
        });
    },
    filterform: function(form_option) {
        var __form = $('.'+form_option),
            __checked_val = '';

        __form.find('input').on('change', function() {
            _checked_val = $('input[name!=cat]', __form).serializeArray();

            _checked_array = new Map();
            _query = '';

            if(_checked_val.length > 0) {
                jQuery.each( _checked_val, function(i, field) {
                    _arr_val = _checked_array.has(field.name) ? _checked_array.get(field.name).toString() + ',' : '';
                    _checked_array.set(field.name, _arr_val + field.value);
                });
                _checked_array.forEach((value, key) => {
                    _query = (_query !== '') ?  _query + '&' + key + '=' + value : '?' + key + '=' + value ;
                });
                mainweb.do_cover('add');
                window.location.href = '/collections/area-rug/' + _query;
            } else {
                mainweb.do_cover('add');
                window.location.href = window.location.href.split('?')[0];
            }
        });

    },
    get_size_range : function() {
        $('body').on('click', '.get_sizerange', function(e) {
            e.preventDefault();

            var formdata = $(this).parents('form').serializeArray(),

            param = '',
            cur_filters = {},
            size_range_form = $(this).parents('form'),
            wf = size_range_form.find('.rwf').val(),
            wt = size_range_form.find('.rwt').val(),
            lf = size_range_form.find('.rlf').val(),
            lt = size_range_form.find('.rlt').val(),
            size_range_q = wf + '-'+wt+'ft by '+lf+'-'+lt+'ft',
            to_location = '/collections/area-rug?',
            query_remove = ['width-ft', 'width-in', 'length-ft', 'length-in', 'size-category', 'wf', 'wt', 'lf', 'lt'];

            $(formdata).each(function(index, obj){
                if(cur_filters[obj.name]) {
                    cur_filters[obj.name] = cur_filters[obj.name] + ',' + obj.value;
                } else {
                    if(query_remove.indexOf(obj.name) < 0) {
                        cur_filters[obj.name] = obj.value;
                    }
                }
            });

            cur_filters["size-range"] = size_range_q;
            param = $.param( cur_filters );
            window.location.href = to_location + param;

        });
    },
    get_size_range_drop : function() {
        $('body').on('change', '.size_range_drop', function() {
            var parent_form = $(this).parents('form');

            parent_form.find('.get_sizerange').parent('div').slideDown();

            if($(this).hasClass('rwf')) {
                base_value = parseInt($(this).val());
                dropdown = parent_form.find('.rwt');
                drop_options = dropdown.find('option');
                drop_option_selected = parseInt(dropdown.val());

                drop_options.each(function() {
                    if(parseInt($(this).attr('value')) < base_value) {
                        $(this).prop('disabled', true);
                    } else {
                        $(this).prop('disabled', false);
                    }
                });

                if(drop_option_selected < base_value) {
                    dropdown.val(base_value);
                }
            }


            if($(this).hasClass('rlf')) {
                base_value = parseInt($(this).val());
                dropdown = parent_form.find('.rlt');
                drop_options = dropdown.find('option');
                drop_option_selected = parseInt(dropdown.val());

                drop_options.each(function() {
                    if(parseInt($(this).attr('value')) < base_value) {
                        $(this).prop('disabled', true);
                    } else {
                        $(this).prop('disabled', false);
                    }
                });

                if(drop_option_selected < base_value) {
                    dropdown.val(base_value);
                }
            }

        });
    },
    do_sort: function () {
        $('body').on('change', '.do-sort', function() {
            var _target = $(this).val();
            mainweb.do_cover('add');
            window.location.href = _target;
        });
    },
    get_collectible_form: function() {
        $('body').on('click', '.get_collectible_form', function(e) {
            var _id = $(this).data('id'),
                _url = '/collectible/form',
                _respond = '';

            var jqxhr = $.ajax({
                method: "POST",
                url: _url,
                data: {id: _id},
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                }
            }).done(function(html) {
                _respond = html;
                mainweb.call_right_canvas('Price Inquiry');

            }).fail(function(err) {
                mainweb.web_alert('error', 'Something went wrong and we are not able to process your request. (er-1014)', 'Price Inquiry'); //type, message, title, btn
            }).always(function() {
                $('.right-canvas-content').html(_respond);
            });

            e.preventDefault();
        });
    },
    call_right_canvas : function(title, width) {
        var canvas_page_cover = '<div class="page_cover_rigth_canvas close-right-canvas"></div>';
        if($('.page_cover_rigth_canvas').length == 0) {
            $('body').append(canvas_page_cover);
        }

        $('body').addClass('no-scroll-canvas');
        var right_canvas = $('.right-canvas-wrapper');
        if(width !== '' && typeof width !== 'undefined') {
            right_canvas.css('max-width', width);
        } else {
            right_canvas.removeAttr('style');
        }
        right_canvas.find('.right-canvas-header-title').html(title);
        right_canvas.addClass('open');
    },
    dismiss_right_canvas : function() {
        var right_canvas = $('.right-canvas-wrapper');
        $('body').on('click', '.close-right-canvas', function(e) {
            $('body').removeClass('no-scroll-canvas');
            right_canvas.removeClass('open');

            $('.page_cover_rigth_canvas').fadeOut(function() {
                $('.page_cover_rigth_canvas').remove();
                right_canvas.find('.right-canvas-header-title').html('');
                right_canvas.find('.right-canvas-content').html('<div class="d-block text-center mt-5"><div class="spinner-border" role="status"></div></div>');
            });

            e.preventDefault();
        });
    },
    call_filters : function() {
        $('body').on('click', '.call-filters', function() {
            var filterform_page_cover = '<div class="page_cover_filterform close-filters"></div>';
            if($('.page_cover_filterform').length == 0) {
                $('body').append(filterform_page_cover);
            }

            $('body').addClass('no-scroll-canvas');

            var filter_wrapper = $('.filterform-wrapper-main');
            filter_wrapper.addClass('open');
        });
    },
    dismiss_filters : function() {
        $('body').on('click', '.close-filters', function() {
            var filter_wrapper = $('.filterform-wrapper-main');
            filter_wrapper.removeClass('open');
            $('body').removeClass('no-scroll-canvas');
            $('.page_cover_filterform').fadeOut(function() {
                $('.page_cover_filterform').remove();
            });
        });
    },
    wish_add : function () {
        $('body').on('click', '.add-to-wishlist', function() {

        });
    },
    get_total_wish_count : function () {
        var __container = $('.in-wishlist-qty');
        var jqxhr = $.ajax({
            method: "POST",
            url: '/wishlist/total',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            }
        }).done(function(html) {
            if(html !== '' && html !== '0') {
                __container.html(html).show();
            } else {
                __container.hide();
            }
        }).fail(function() {
            //mainweb.web_alert('error', 'Something went wrong and we are not able to load your shopping cart. (er-100)', 'Cart Error'); //type, message, title, btn
        }).always(function() {
            //After all, do something, right?
        });
    },

    //CART

    get_total_cart_count : function () {
        var __container = $('.in-cart-qty');
        var jqxhr = $.ajax({
            method: "POST",
            url: '/cart/total',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            }
        }).done(function(html) {
            if(html !== '' && html !== '0') {
                __container.html(html).show();
            } else {
                __container.hide();
            }
        }).fail(function() {
            //mainweb.web_alert('error', 'Something went wrong and we are not able to load your shopping cart. (er-100)', 'Cart Error'); //type, message, title, btn
        }).always(function() {
            //After all, do something, right?
        });
    },

    get_cart_full : function () {
        var _full_cart_wrapper = $('.full-cart-wrapper'),
            _full_cart_spinner = '<div class="full-cart-cover"><div class="spinner-border" role="status"></div></div>';


        if(_full_cart_wrapper.length <= 0) {
            return;
        }


        if(_full_cart_wrapper.find('.spinner-border').length <= 0) {
            $('.full-cart-container').append(_full_cart_spinner);
        }


        var jqxhr = $.ajax({
            method: "POST",
            url: '/cart/full',
            data: { nocache: Math.random(1000, 10000) },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            }
        }).done(function(html) {
            full_content = html;
        }).fail(function() {
            $('.full-cart-cover').remove();
            mainweb.web_alert('error', 'Something went wrong and we are not able to load your shopping cart. (er-500)', 'Cart Error'); //type, message, title, btn
        }).always(function() {
            mainweb.get_total_cart_count();
            setTimeout(function() {
                _full_cart_wrapper.html(full_content);
            }, 500);
        });
    },
    get_cart_mini : function () {
        var mini_content = '',
            path_name = window.location.pathname,
            do_canvas = (path_name == '/cart/checkout') ? false : true;


        if(!do_canvas) {
            mainweb.web_alert('warning', 'Are you sure you want to leave this page?', 'Cart Warning', '<a href="javascript:void(0);" class="btn btn-light btn-md web-alert-close">Cancel</a><a href="/cart" class="btn btn-primary btn-md ms-3">Yes</a>');
            return;
        } else {
            mainweb.get_total_cart_count();
            mainweb.call_right_canvas('Shopping Cart');
        }
        var jqxhr = $.ajax({
            method: "POST",
            url: '/cart/mini',
            data: { state : '' },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            }
        }).done(function(html) {
            mini_content = html;
        }).fail(function() {
            mainweb.web_alert('error', 'Something went wrong and we are not able to load your shopping cart. (er-200)', 'Cart Error'); //type, message, title, btn
        }).always(function() {
            $('.right-canvas-content').html(mini_content);
        });
    },
    get_cart_grand_total: function() {

        $('body').on('change', '.shpstate', function() {
            var _container = $('.crt_g_total'),
                _stt = $(this).val(),
                _spinner = '<div class="mini-cart-cover"><div class="spinner-border" role="status"></div></div>';

                _container.append(_spinner);


            var jqxhr = $.ajax({
                method: "POST",
                url: '/cart/gttl',
                data: { stt: _stt },
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                }
            }).done(function(html) {
                full_content = html;
            }).fail(function() {
                $('.mini-cart-cover').remove();
                mainweb.web_alert('error', 'Something went wrong and we are not able to load your shopping cart. (er-500)', 'Cart Error'); //type, message, title, btn
            }).always(function() {
                _container.html(full_content);
            });

        });

        $('body').on('change', '.getship', function() {
            var _container = $('.crt_g_total'),
                _zp = $('#zip').val(),
                _cy = $('#country').val() != '' ? $('#country').val() : '',
                _spinner = '<div class="mini-cart-cover"><div class="spinner-border" role="status"></div></div>';

            if(_zp && _zp.length >= 5) {

                _container.append(_spinner);

                var jqxhr = $.ajax({
                    method: "POST",
                    url: '/cart/gttl',
                    data: { zip: _zp, country: _cy, ajax: 1 },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                    }
                }).done(function(html) {
                    full_content = html;
                }).fail(function() {
                    $('.mini-cart-cover').remove();
                    mainweb.web_alert('error', 'Something went wrong and we are not able to load your shopping cart. (er-500)', 'Cart Error'); //type, message, title, btn
                }).always(function() {
                    _container.html(full_content);
                });
            }
        });
    },
    get_cart_delete : function(btn, request_type) {
        var _form_btn = btn,
        _form = _form_btn.parents('form');
        _form_id = _form.find('.del-item-id').val();
        _form_method = _form.find('input[name="_method"]').val(),
        _parent_li = _form_btn.parents('li'),
        _spinner = '<div class="mini-cart-cover"><div class="spinner-border" role="status"></div></div>';
        _parent_li.append(_spinner);

        var jqxhr = $.ajax({
            method: "POST",
            url: '/cart/del',
            data: { id: _form_id, ajax: 1, _method : _form_method },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            }
        }).done(function(html) {
            updated_content = html;
        }).fail(function() {
            $('.mini-cart-cover').remove();
            mainweb.web_alert('error', 'Something went wrong and we are not able to load your shopping cart. (er-300)', 'Cart Error'); //type, message, title, btn
        }).always(function() {
            if(updated_content == '1') {
                setTimeout(function() {
                    _parent_li.slideUp(function() {
                        if($('.right-canvas-wrapper').hasClass('open')) {
                            mainweb.get_cart_mini();
                        }
                        if($('.full-cart-container').length > 0) {
                            mainweb.get_cart_full();
                        }
                        mainweb.get_total_cart_count();
                    });
                }, 500)
            } else {
                $('.mini-cart-cover').remove();
                mainweb.web_alert('error', 'Something went wrong and we are not able to load your shopping cart. (er-400)', 'Cart Error'); //type, message, title, btn
            }
        });

    },
    get_cart_qty : function () {
        $('body').on('change', '.cart-qty-setter', function(e) {
            var _form = $(this).parent('.cart-qty-setter-form');
                _form_id = _form.find('.item-id').val();
                _form_qty = $(this).val(),
                _parent_li = $(this).parents('li'),
                _spinner = '<div class="mini-cart-cover"><div class="spinner-border" role="status"></div></div>';
                _parent_li.append(_spinner);

            var jqxhr = $.ajax({
                method: "POST",
                url: '/cart/qty',
                data: { id: _form_id, qty: _form_qty, ajax: 1},
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                }
            }).done(function(html) {
                updated_content = html;
            }).fail(function() {
                $('.mini-cart-cover').remove();
                mainweb.web_alert('error', 'Something went wrong and we are not able to load your shopping cart. (er-700)', 'Cart Error'); //type, message, title, btn
            }).always(function() {
                if(updated_content == '1') {
                    setTimeout(function() {
                        mainweb.get_cart_full();
                    }, 1000);
                }
                else if (updated_content == '2') {
                    $('.mini-cart-cover').remove();
                    mainweb.web_alert('error', 'Invalid Quantity.', 'Cart Error'); //type, message, title, btn
                }
                else {
                    $('.mini-cart-cover').remove();
                    mainweb.web_alert('error', 'Something went wrong and we are not able to load your shopping cart. (er-700)', 'Cart Error'); //type, message, title, btn
                }
            });

            e.preventDefault();
        });
    },
    add_to_cart : function() {
        $('body').on('click', '.do_add_cart_item', function(e) {
            var _url = '/cart/add',
                _frm = $(this).parents('form'),
                _dta = _frm.serialize(),
                _dta = _dta + '&ajax=1',
                _respond = null;
                e.preventDefault();

                mainweb.do_cover('add');
            var jqxhr = $.ajax({
                method: "POST",
                url: _url,
                data: _dta,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                }
            }).done(function(html) {
                _respond = html;
            }).fail(function(err) {
                mainweb.do_cover('remove');
                mainweb.web_alert('error', 'Something went wrong and we are not able to process your request. (er-1011)', 'Cart Error'); //type, message, title, btn
            }).always(function() {
                mainweb.do_cover('remove');
                if(_respond.indexOf("error::") >= 0) {
                    $message = _respond.split('::')[0];
                    mainweb.web_alert('error', $message, 'Cart Error');
                } else {
                    mainweb.get_cart_mini();
                }
            });
        });
    },

    //View
    gallery : function() {
        $('body').on('mouseenter', '.gallery-thumb li', function() {
            var _url = $(this).data('gallery'),
                _ori = $(this).data('ori'),
                _target = $('.gallery-main').find('img'),
                _zoom_container = $('.gallery-main').find('.containerZoom');

                _target.removeClass('hrz');
                _target.removeClass('vrcl');
                _target.addClass(_ori);
                _target.prop('src', _url);

                //If zoom exist.
                if(_zoom_container.length > 0) {
                    _zoom_container.css('background-image', 'url('+ _url +')');
                }
        });
    },
    view_zoom: function() {
        $('#main-gallery').imageZoom({
            zoom: 200
        });
    },
    get_social_share : function () {

        $('body').on('click', '.detail-share', function(e) {
            var s_url = $(this).data('url'),
                s_description = $(this).data('description'),
                s_title = $(this).data('title'),
                s_media = $(this).data('media') != '' ? $(this).data('media') : $('.gallery-main-image-wrapper').find('img').prop('src'),
                s_via = $(this).data('via'),
                s_type = $(this).data('type').toLowerCase(),
                s_final_url = "";
            switch (s_type) {
                case "facebook":
                    s_final_url = "https:\/\/www.facebook.com\/sharer\/sharer.php?s=100&p[title]=" + s_title + "&p[summary]=" + s_description + "&p[url]=" + s_url + "&p[images][0]=" + s_media + "";
                    break;
                case "twitter":
                    s_final_url = "https:\/\/twitter.com\/share?url=" + encodeURIComponent(s_url) + "&via=" + s_via + "&text=" + encodeURIComponent(s_title) + "";
                    break;
                case "pinterest":
                    s_final_url = "http:\/\/pinterest.com\/pin\/create\/button\/?url=" + s_url + "&media=" + encodeURIComponent(s_media) + "&description=" + s_description + "";
                    break;
                case "googleplus":
                    s_final_url = "https:\/\/plus.google.com\/share?url=" + s_url + "";
                    break;
            }
            window.open(s_final_url, '', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=600, height=400, top=100, left=100');
            e.preventDefault();
        });
    },
    gallery_show : function() {
        var _container = `
        <div class="gallery-show-wrapper d-block">
            <div class="container">
                <div class="row">
                    <div class="col-md-4">
                        <p class="gallery-show-title text-end p-0 mt-2 mt-md-5 d-none d-md-block"></p>
                        <p class="gallery-show-description text-md-end p-0 mt-2 d-none d-md-block"></p>
                        <div class="d-block text-end mt-4 mb-4">
                        <a href="javascript:void(0);" class="btn btn-outline-primary btn-sm gallery-show-close">CLOSE</a>
                        </div>
                        <div class="scroll-hint-up-down d-none d-md-flex" style="margin-left: auto;">
                            <div>
                                <svg class="bi mb-2" width="20" height="20" fill="currentColor">
                                    <use xlink:href="/bootstrap-icons/bootstrap-icons.svg#arrow-up"/>
                                </svg>
                            </div>
                            <div>Scroll</div>
                            <div>
                                <svg class="bi mt-2" width="20" height="20" fill="currentColor">
                                    <use xlink:href="/bootstrap-icons/bootstrap-icons.svg#arrow-down"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="gallery-show-box"></div>
                    </div>
                </div>
            </div>
        </div>`;

        $('body').on('click', '.gallery-main-image-wrapper', function() {
            var _body = $('body'),
                _image_bin = $('.gallery-wrapper-trail'),
                _title = $('.gallery-wrapper-trail').data("title"),
                _description = $('.detail-description-text');

                mainweb.do_cover('add');
                _body.addClass('no-scroll-body').append(_container);

                _image_bin.find('img').each(function() {
                    $('body').find('.gallery-show-box').append('<img src="'+ $(this).prop('src') +'">');
                });
                $('body').find('.gallery-show-title').text(_title);
                if(_description.length > 0) {
                    $('body').find('.gallery-show-description').text(_description.text());
                }

                $('.gallery-show-wrapper').fadeIn(300, function() {
                    mainweb.do_cover('remove');
                });

                $(document).on('keyup', function(e) {
                    if (e.key == 'Escape') {
                        $('.gallery-show-close').trigger('click');
                    }
                });

        });
    },
    gallery_remove: function() {
        $('body').on('click', '.gallery-show-close', function() {
            $('.gallery-show-wrapper').fadeOut(300, function() {
                $('.gallery-show-wrapper').remove();
                $('body').removeClass('no-scroll-body');
            });
        });
    },
    get_review_form: function() {
        $('body').on('click', '.writeareview', function() {
            var _form = $('.review-collect-form');
            if(_form.is(':visible')) {
                _form.slideUp(300);
            } else {
                _form.slideDown(300);
            }
        });

    },
    scrollable: function(scrollable_class) {
        var scrollable = $('.'+scrollable_class);
        var ele = scrollable;
        var pos = { top: 0, left: 0, x: 0, y: 0 };

        var mouseDownHandler = function(e) {
            pos = {
                left: ele.scrollLeft(),
                top: ele.scrollTop(),
                x: e.clientX,
                y: e.clientY,
            };

            scrollable.on('mousemove', mouseMoveHandler);
            scrollable.on('mouseup', mouseUpHandler);
        };

        var mouseMoveHandler = function(e) {
            // How far the mouse has been moved
            var dx = e.clientX - pos.x;
            var dy = e.clientY - pos.y;

            // Scroll the element
            ele.scrollTop(pos.top - dy);
            ele.scrollLeft(pos.left - dx);
        };

        var mouseUpHandler = function() {
            scrollable.off();
            scrollable.on('mousedown', mouseDownHandler);
        };

        scrollable.on('mousedown', mouseDownHandler);
    },
    get_qty_click : function() {

        $('body').on('click', '.qtym', function(e) {
            var _current = parseInt($('.qtyinp').val());
            if(_current > 1) {
                $('.qtyinp').val(_current - 1);
            }
            e.preventDefault();
        });

        $('body').on('click', '.qtyp', function(e) {
            var _current = parseInt($('.qtyinp').val());
            $('.qtyinp').val(_current + 1);
            e.preventDefault();
        });
    },
    get_pr_question_form: function() {
        $('body').on('click', '.get_pr_question_form', function(e) {

            var _id = $(this).data('id'),
                _url = '/question/form',
                _respond = '';

            var jqxhr = $.ajax({
                method: "POST",
                url: _url,
                data: {id: _id},
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                }
            }).done(function(html) {
                _respond = html;
                mainweb.call_right_canvas('Question About an Item');

            }).fail(function(err) {
                mainweb.web_alert('error', 'Something went wrong and we are not able to process your request. (er-1018)', 'Question About an Item'); //type, message, title, btn
            }).always(function() {
                $('.right-canvas-content').html(_respond);
            });

            e.preventDefault();
        });
    },
    view_init : function() {
        mainweb.gallery();
        mainweb.view_zoom();
        mainweb.add_to_cart();
        mainweb.get_social_share();
        mainweb.gallery_show();
        mainweb.gallery_remove();
        mainweb.scrollable('also-like-inner-wrapper');
        mainweb.get_review_form();
        mainweb.get_qty_click();

        $('[data-toggle="tooltip"]').tooltip();

        $('body').on('click', '.detail-item-option', function(e) {
            var _url = $(this).prop('href');
            mainweb.get_item_options(_url);
            e.preventDefault();
        });

        $('body').on('change', '.detail-item-option-drop', function(e) {
            var _url = $(this).val();
            mainweb.get_item_options(_url);
            e.preventDefault();
        });
    },
    toggle_billing_address : function () {
        $('#diffaddress').on('change', function() {
            var _container = $('.diffaddress_wrapper');
            if($(this).is(':checked')) {
                _container.show();
            } else {
                _container.hide();
            }
        });
    },
    checkout: function() {
        $('body').on('click', '.checkout-btn', function(e) {
            var __cover = '<div class="page_cover"><div class="spinner-border" role="status"></div></div>';
            $('body').addClass('no-scroll');
            $('body').append(__cover);
            setTimeout(function() {
                $('#checkout').submit();
            }, 500);
            e.preventDefault();
        });
    },
    cart_init : function () {
        mainweb.get_cart_grand_total();
        mainweb.get_cart_qty();
        mainweb.toggle_billing_address();
        mainweb.checkout();
    }
}

$(function() {
    mainweb.init();
});
